import { API } from '@utils/axios'
import { IAPI } from 'AppTypes'

class StoreSpecialTypeAPI implements IAPI {
  prefix = '/StoreSpecialTypeManagement'

  fetchList () {
    return API.get(`${this.prefix}/GetList`)
  }

  fetchSingle (id: string) {
    return API.get<TStoreManagement.State['specialTypeUpsert']>(`${this.prefix}/GetById?id=${id}`)
  }

  async create (body: TStoreManagement.State['specialTypeUpsert']) {
    const response = await API.post(`${this.prefix}/Create`, body)
    return response.data
  }

  async update (body: TStoreManagement.State['specialTypeUpsert']) {
    const response = await API.put(`${this.prefix}/Update`, body)
    return response.data
  }

  async delete (id: string) {
    return API.delete(`${this.prefix}/Delete?id=${id}`)
  }

  async updateStoresSpecialType (params: any) {
    const response = await API.post(`${this.prefix}/UpdateStoresSpecialType`, params)
    return response.data
  }
}

export const storeSpecialTypeApi = new StoreSpecialTypeAPI()
